import { createIcon } from "@chakra-ui/react";

// Source: https://fontawesome.com/icons/bolt?s=solid
export default createIcon({
  displayName: "Bolt",
  viewBox: "0 0 384 512",
  path: (
    <path
      d="M240.5 224H352C365.3 224 377.3 232.3 381.1 244.7C386.6 257.2 383.1 271.3 373.1 280.1L117.1 504.1C105.8 513.9 89.27 514.7 77.19 505.9C65.1 497.1 60.7 481.1 66.59 467.4L143.5 288H31.1C18.67 288 6.733 279.7 2.044 267.3C-2.645 254.8 .8944 240.7 10.93 231.9L266.9 7.918C278.2-1.92 294.7-2.669 306.8 6.114C318.9 14.9 323.3 30.87 317.4 44.61L240.5 224z"
      fill="currentColor"
    />
  ),
});
